//import { combineReducers } from 'redux-immutable';
import { handleActions, combineActions } from 'redux-actions';
import { Map } from 'immutable';

import actions from '../actions';

//REDUCERS
const availCalendarActions = actions.availCalendar;
export default handleActions(
  {
    [combineActions(availCalendarActions.getAsync.toString(), availCalendarActions.setRequested.toString())]: (
      avails,
      { payload }
    ) => {
      //const prevHotelAvail = avails.getIn(payload.get("availKey"), Map());
      //return avails.setIn(payload.get("availKey"), prevHotelAvail.merge(payload.get("avail")));
      payload.forEach((avail, hotelId) => {
        avail.keySeq().forEach(queryString => {
          avails = avails.setIn([hotelId,queryString], avails.getIn([hotelId, queryString],Map()).merge(avail.getIn([queryString])));
        });
      });
      return avails;
    },
  },
  Map()
);

//REDUCERS
//export default combineReducers({ hotel }, Record({ hotel: undefined }));
